import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import DataTable from "react-data-table-component";
import { Tooltip } from "@material-ui/core";
import AdminService from "../../../services/admin.service";
import TextField from "@mui/material/TextField";
import { toast } from "react-toastify";
import './manageGids.css'
import ImportData from "../../../Common/components/import/importData";
import ExportWithData from "../../../Common/components/export/ExportWithData";
import ExportWithoutData from "../../../Common/components/export/ExportWithoutData";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={ value !== index }
            id={ `vertical-tabpanel-${index}` }
            aria-labelledby={ `vertical-tab-${index}` }
            { ...other }
        >
            { value === index && (
                <Box sx={ { p: 3 } }>
                    <Typography>{ children }</Typography>
                </Box>
            ) }
        </div>
    );
}

function a11yProps(index) {
    console.log('newvalue index', index)
    return {
        id: `vertical-tab-${index}`,
        "aria-controls": `vertical-tabpanel-${index}`,
    };
}

const LanguageTab = (props) => {
    const [searchValue, setSearchValue] = useState('')
    const [value, setValue] = useState(0);
    const [indicatorData, setIndicatorData] = useState([]);
    const [forIndicatorInputs, setIndicatorValues] = useState([])
    const [unitData, setUnitData] = useState([]);
    const [forUnitInputs, setUnitValues] = useState([])
    const [subgroupData, setSubgroupData] = useState([]);
    const [forSubgroupInputs, setSubgroupValues] = useState([])
    const [subgroupDimensionData, setSubgroupDimensionData] = useState([]);
    const [forSubgroupDimensionInputs, setSubgroupDimensionValues] = useState([])
    const [areaData, setAreaData] = useState([]);
    const [forAreaInputs, setAreaValues] = useState([])
    const [sourceData, setSourceData] = useState([]);
    const [forSourceInputs, setSourceValues] = useState([])
    const [timePeriodData, setTimeperiodData] = useState([]);
    const [forTimeperiodInputs, setTimeperiodValues] = useState([])
    const [metaData, setMetaData] = useState([]);
    const [forMetaInputs, setMetaValues] = useState([])

    console.log('tabvalue', value)

    const handleChange = (event, newValue) => {
        setValue(newValue);
        // setSearch(false);
        console.log('newvalue', newValue)
    };

    const getIndicatorData = async () => {
        const result = await AdminService.httpGet(`/data-sdmx/sdmx/getCodifyList/${1}`)
        console.log('getIndicatorData', result.data.list)
        const obj = {}


        result.data.list.forEach((data) => {
            // let obj = {}
            obj[data._id] = {
                sdmx_code: data.sdmx_code,
                name: data.name
            }
            // forDataToSet.push(obj)
        })
        console.log('forDataToSet', obj)
        setIndicatorData(result.data.list)
        setIndicatorValues(obj)
    }

    const getUnitData = async () => {
        const result = await AdminService.httpGet(`/data-sdmx/sdmx/getCodifyList/${2}`)
        console.log('getunitdata', result.data.list)
        const obj = {}


        result.data.list.forEach((data) => {
            obj[data._id] = {
                sdmx_code: data.sdmx_code,
                name: data.name
            }
        })
        console.log('forDataToSet', obj)
        setUnitData(result.data.list)
        setUnitValues(obj)
    }

    const getSubgroupData = async () => {
        const result = await AdminService.httpGet(`/data-sdmx/sdmx/getCodifyList/${3}`)
        console.log('getsubgroupdata', result.data.list)
        const obj = {}


        result.data.list.forEach((data) => {
            obj[data._id] = {
                sdmx_code: data.sdmx_code,
                name: data.name
            }
        })
        console.log('forDataToSet', obj)
        setSubgroupData(result.data.list)
        setSubgroupValues(obj)
    }

    const getSubgroupDimensionData = async () => {
        const result = await AdminService.httpGet(`/data-sdmx/sdmx/getCodifyList/${4}`)
        console.log('getsubgroupdata', result.data.list)
        const obj = {}


        result?.data?.list?.forEach((data) => {
            obj[data._id] = {
                sdmx_code: data.sdmx_code,
                name: data.name
            }
        })
        console.log('forDataToSet', result.data.list)
        setSubgroupDimensionData(result.data.list)
        setSubgroupDimensionValues(obj)
    }


    const getAreaData = async () => {
        const result = await AdminService.httpGet(`/data-sdmx/sdmx/getCodifyList/${5}`)
        console.log('getareadata', result.data.list)
        const obj = {}


        result.data.list.forEach((data) => {
            obj[data._id] = {
                sdmx_code: data.sdmx_code,
                name: data.name
            }
        })
        console.log('forDataToSet', obj)
        setAreaData(result.data.list)
        setAreaValues(obj)
    }

    const getSourceData = async () => {
        const result = await AdminService.httpGet(`/data-sdmx/sdmx/getCodifyList/${6}`)
        console.log('getareadata', result.data.list)
        const obj = {}


        result.data.list.forEach((data) => {
            obj[data._id] = {
                sdmx_code: data.sdmx_code,
                name: data.name
            }
        })
        console.log('forDataToSet', obj)
        setSourceData(result.data.list)
        setSourceValues(obj)
    }

    const getTimePeriodData = async () => {
        const result = await AdminService.httpGet(`/data-sdmx/sdmx/getCodifyList/${7}`)
        console.log('getareadata', result.data.list)
        const obj = {}


        result.data.list.forEach((data) => {
            obj[data._id] = {
                sdmx_code: data.sdmx_code,
                name: data.name
            }
        })
        console.log('forDataToSet', obj)
        setTimeperiodData(result.data.list)
        setTimeperiodValues(obj)
    }

    const getMetaData = async () => {
        const result = await AdminService.httpGet(`/data-sdmx/sdmx/getCodifyList/${8}`)
        console.log('getareadata', result.data.list)
        const obj = {}


        result.data.list.forEach((data) => {
            obj[data._id] = {
                sdmx_code: data.sdmx_code,
                name: data.name
            }
        })
        console.log('forDataToSet', obj)
        setMetaData(result.data.list)
        setMetaValues(obj)
    }

    const handleInputsOfIndicator = (event, ele) => {
        setIndicatorValues({ ...forIndicatorInputs, [ele._id]: { sdmx_code: event.target.value, name: ele.name } })
        console.log('handleinput', ele._id, forIndicatorInputs)
    }

    const saveIndicatorGid = async (dataToSend) => {
        const result = await AdminService.httpPost(`/data-sdmx/sdmx/update-sdmx-code`, dataToSend)
        toast.success("Saved Succesfully");
        getIndicatorData()
    };

    ////indicator
    const columns = [
        {
            name: "Indicator",
            selector: (row) => row?.name,
            sortable: true,
            // maxWidth: "40%",
        },
        {
            name: "Indicator GID",
            selector: (ele) => (
                <div className="inputform_style">
                    <div className="languageInput">
                        <TextField
                            onChange={ (event) => {
                                handleInputsOfIndicator(event, ele)
                            } }
                            key={ ele?._id }
                            placeholder="Enter GID"
                            value={ forIndicatorInputs[ele?._id]?.sdmx_code }
                            variant="outlined"
                        />
                    </div>
                </div>
            ),
            sortable: true,
            // maxWidth: "40%",
        },
        {
            name: "Action",
            // width: "200px",
            cell: (row) => (
                <>
                    <div
                        onClick={ () =>
                            saveIndicatorGid(
                                {
                                    name: row?.name,
                                    sdmxcode: forIndicatorInputs[row._id].sdmx_code,
                                    type: 1
                                }
                            )
                        }
                    >
                        <img
                            alt=""
                            className="cursor-pointer saveBtn"
                            src="assets/lib/images/home/save.svg"
                        />
                    </div>
                </>
            ),
            sortable: false,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const handleInputsForUnit = (event, ele) => {
        setUnitValues({ ...forUnitInputs, [ele._id]: { sdmx_code: event.target.value, name: ele.name } })
        console.log('handleinput', ele._id, forUnitInputs)
    }

    const saveUnitGid = async (dataToSend) => {
        const result = await AdminService.httpPost(`/data-sdmx/sdmx/update-sdmx-code`, dataToSend)
        toast.success("Saved Succesfully");
        getUnitData()
    }

    //unit
    const columns1 = [
        {
            name: "Unit",
            selector: (row) => row?.name,
            sortable: true,
            // maxWidth: "377px",
        },
        {
            name: "Unit GID",
            selector: (ele) => (
                <div className="inputform_style">
                    <div className="languageInput">
                        <TextField
                            onChange={ (event) => {
                                handleInputsForUnit(event, ele)
                            } }
                            key={ ele?._id }
                            placeholder="Enter GID"
                            value={ forUnitInputs[ele?._id]?.sdmx_code }
                            variant="outlined"
                        />
                    </div>
                </div>
            ),
            sortable: true,
            // maxWidth: "377px",
        },
        {
            name: "Action",
            // width: "200px",
            cell: (row) => (
                <>
                    <div
                        onClick={ () =>
                            saveUnitGid(
                                {
                                    name: row?.name,
                                    sdmxcode: forUnitInputs[row._id].sdmx_code,
                                    type: 2
                                }
                            )
                        }
                    >
                        <img
                            alt=""
                            className="cursor-pointer saveBtn"
                            src="assets/lib/images/home/save.svg"
                        />
                    </div>
                </>
            ),
            sortable: false,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];


    const handleInputsForSubgroup = (event, ele) => {
        setSubgroupValues({ ...forSubgroupInputs, [ele._id]: { sdmx_code: event.target.value, name: ele.name } })
        console.log('handleinput', ele._id, forSubgroupInputs)
    }

    const saveSubgroupGid = async (dataToSend) => {
        const result = await AdminService.httpPost(`/data-sdmx/sdmx/update-sdmx-code`, dataToSend)
        toast.success("Saved Succesfully");
        getSubgroupData()
    }

    //subgroup
    const columns2 = [
        {
            name: "Subgroup",
            selector: (row) => row?.name,
            sortable: true,
            // maxWidth: "377px",
        },
        {
            name: "Subgroup GID",
            selector: (ele) => (
                <div className="inputform_style">
                    <div className="languageInput">
                        <TextField
                            onChange={ (event) => {
                                handleInputsForSubgroup(event, ele)
                            } }
                            key={ ele?._id }
                            placeholder="Enter GID"
                            value={ forSubgroupInputs[ele?._id]?.sdmx_code }
                            variant="outlined"
                        />
                    </div>
                </div>
            ),
            sortable: true,
            // maxWidth: "377px",
        },
        {
            name: "Action",
            // width: "200px",
            cell: (row) => (
                <>
                    <div
                        onClick={ () =>
                            saveSubgroupGid(
                                {
                                    name: row?.name,
                                    sdmxcode: forSubgroupInputs[row._id].sdmx_code,
                                    type: 3
                                }
                            )
                        }
                    >
                        <img
                            alt=""
                            className="cursor-pointer saveBtn"
                            src="assets/lib/images/home/save.svg"
                        />
                    </div>
                </>
            ),
            sortable: false,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const handleInputsForSubgroupDimension = (event, ele) => {
        setSubgroupDimensionValues({ ...forSubgroupDimensionInputs, [ele._id]: { sdmx_code: event.target.value, name: ele.name } })
        console.log('handleinput', ele._id, forSubgroupDimensionInputs)
    }

    const saveSubgroupDimensionGid = async (dataToSend) => {
        const result = await AdminService.httpPost(`/data-sdmx/sdmx/update-sdmx-code`, dataToSend)
        toast.success("Saved Succesfully");
        getSubgroupDimensionData()
    }

    //subgroup
    const columns3 = [
        {
            name: "Subgroup Dimension",
            selector: (row) => row?.name,
            sortable: true,
            // maxWidth: "377px",
        },
        {
            name: "Subgroup Dimension GID",
            selector: (ele) => (
                <div className="inputform_style">
                    <div className="languageInput">
                        <TextField
                            onChange={ (event) => {
                                handleInputsForSubgroupDimension(event, ele)
                            } }
                            key={ ele?._id }
                            placeholder="Enter GID"
                            value={ forSubgroupDimensionInputs[ele?._id]?.sdmx_code }
                            variant="outlined"
                        />
                    </div>
                </div>
            ),
            sortable: true,
            // maxWidth: "377px",
        },
        {
            name: "Action",
            // width: "200px",
            cell: (row) => (
                <>
                    <div
                        onClick={ () =>
                            saveSubgroupDimensionGid(
                                {
                                    name: row?.name,
                                    sdmxcode: forSubgroupDimensionInputs[row._id].sdmx_code,
                                    type: 4
                                }
                            )
                        }
                    >
                        <img
                            alt=""
                            className="cursor-pointer saveBtn"
                            src="assets/lib/images/home/save.svg"
                        />
                    </div>
                </>
            ),
            sortable: false,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const handleInputsForArea = (event, ele) => {
        setAreaValues({ ...forAreaInputs, [ele._id]: { sdmx_code: event.target.value, name: ele.name } })
        console.log('handleinput', ele._id, forAreaInputs)
    }

    const saveAreaGid = async (dataToSend) => {
        const result = await AdminService.httpPost(`/data-sdmx/sdmx/update-sdmx-code`, dataToSend)
        toast.success("Saved Succesfully");
        getAreaData()
    }

    //area
    const columns4 = [
        {
            name: "Area",
            selector: (row) => row?.name,
            sortable: true,
            // maxWidth: "377px",
        },
        {
            name: "Area GID",
            selector: (ele) => (
                <div className="inputform_style">
                    <div className="languageInput">
                        <TextField
                            onChange={ (event) => {
                                handleInputsForArea(event, ele)
                            } }
                            key={ ele?._id }
                            placeholder="Enter GID"
                            value={ forAreaInputs[ele?._id]?.sdmx_code }
                            variant="outlined"
                        />
                    </div>
                </div>
            ),
            sortable: true,
            // maxWidth: "377px",
        },
        {
            name: "Action",
            // width: "200px",
            cell: (row) => (
                <>
                    <div
                        onClick={ () =>
                            saveAreaGid(
                                {
                                    name: row?.name,
                                    sdmxcode: forAreaInputs[row._id].sdmx_code,
                                    type: 5
                                }
                            )
                        }
                    >
                        <img
                            alt=""
                            className="cursor-pointer saveBtn"
                            src="assets/lib/images/home/save.svg"
                        />
                    </div>
                </>
            ),
            sortable: false,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const handleInputsForSource = (event, ele) => {
        setSourceValues({ ...forSourceInputs, [ele._id]: { sdmx_code: event.target.value, name: ele.name } })
        console.log('handleinput', ele._id, forSourceInputs)
    }

    const saveSourceGid = async (dataToSend) => {
        const result = await AdminService.httpPost(`/data-sdmx/sdmx/update-sdmx-code`, dataToSend)
        toast.success("Saved Succesfully");
        getSourceData()
    }

    //source
    const columns5 = [
        {
            name: "Source",
            selector: (row) => row?.name,
            sortable: true,
            // maxWidth: "377px",
        },
        {
            name: "Source GID",
            selector: (ele) => (
                <div className="inputform_style">
                    <div className="languageInput">
                        <TextField
                            onChange={ (event) => {
                                handleInputsForSource(event, ele)
                            } }
                            key={ ele?._id }
                            placeholder="Enter GID"
                            value={ forSourceInputs[ele?._id]?.sdmx_code }
                            variant="outlined"
                        />
                    </div>
                </div>
            ),
            sortable: true,
            // maxWidth: "377px",
        },
        {
            name: "Action",
            // width: "200px",
            cell: (row) => (
                <>
                    <div
                        onClick={ () =>
                            saveSourceGid(
                                {
                                    name: row?.name,
                                    sdmxcode: forSourceInputs[row._id].sdmx_code,
                                    type: 6
                                }
                            )
                        }
                    >
                        <img
                            alt=""
                            className="cursor-pointer saveBtn"
                            src="assets/lib/images/home/save.svg"
                        />
                    </div>
                </>
            ),
            sortable: false,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const handleInputsForTimeperiod = (event, ele) => {
        setTimeperiodValues({ ...forTimeperiodInputs, [ele._id]: { sdmx_code: event.target.value, name: ele.name } })
        console.log('handleinput', ele._id, forTimeperiodInputs)
    }

    const saveTimeperiodGid = async (dataToSend) => {
        const result = await AdminService.httpPost(`/data-sdmx/sdmx/update-sdmx-code`, dataToSend)
        toast.success("Saved Succesfully");
        getTimePeriodData()
    }

    //Time Period
    const columns6 = [
        {
            name: "Time Period",
            selector: (row) => row?.name,
            sortable: true,
            // maxWidth: "377px",
        },
        {
            name: "Time Period GID",
            selector: (ele) => (
                <div className="inputform_style">
                    <div className="languageInput">
                        <TextField
                            onChange={ (event) => {
                                handleInputsForTimeperiod(event, ele)
                            } }
                            key={ ele?._id }
                            placeholder="Enter GID"
                            value={ forTimeperiodInputs[ele?._id]?.sdmx_code }
                            variant="outlined"
                        />
                    </div>
                </div>
            ),
            sortable: true,
            // maxWidth: "377px",
        },
        {
            name: "Action",
            // width: "200px",
            cell: (row) => (
                <>
                    <div
                        onClick={ () =>
                            saveTimeperiodGid(
                                {
                                    name: row?.name,
                                    sdmxcode: forTimeperiodInputs[row._id].sdmx_code,
                                    type: 7
                                }
                            )
                        }
                    >
                        <img
                            alt=""
                            className="cursor-pointer saveBtn"
                            src="assets/lib/images/home/save.svg"
                        />
                    </div>
                </>
            ),
            sortable: false,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const handleInputsForMeta = (event, ele) => {
        setMetaValues({ ...forMetaInputs, [ele._id]: { sdmx_code: event.target.value, name: ele.name } })
        console.log('handleinput', ele._id, forMetaInputs)
    }

    const saveMetaGid = async (dataToSend) => {
        const result = await AdminService.httpPost(`/data-sdmx/sdmx/update-sdmx-code`, dataToSend)
        toast.success("Saved Succesfully");
        getMetaData()
    }

    //Time Period
    const columns7 = [
        {
            name: "Meta",
            selector: (row) => row?.name,
            sortable: true,
            // maxWidth: "377px",
        },
        {
            name: "Meta GID",
            selector: (ele) => (
                <div className="inputform_style">
                    <div className="languageInput">
                        <TextField
                            onChange={ (event) => {
                                handleInputsForMeta(event, ele)
                            } }
                            key={ ele?._id }
                            placeholder="Enter GID"
                            value={ forMetaInputs[ele?._id]?.sdmx_code }
                            variant="outlined"
                        />
                    </div>
                </div>
            ),
            sortable: true,
            // maxWidth: "377px",
        },
        {
            name: "Action",
            // width: "200px",
            cell: (row) => (
                <>
                    <div
                        onClick={ () =>
                            saveMetaGid(
                                {
                                    name: row?.name,
                                    sdmxcode: forMetaInputs[row._id].sdmx_code,
                                    type: 8
                                }
                            )
                        }
                    >
                        <img
                            alt=""
                            className="cursor-pointer saveBtn"
                            src="assets/lib/images/home/save.svg"
                        />
                    </div>
                </>
            ),
            sortable: false,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    useEffect(() => {
        if (value === 0) {
            getIndicatorData();
        } else if (value === 1) {
            getUnitData()
        } else if (value === 2) {
            getSubgroupData()
        } else if (value === 3) {
            getSubgroupDimensionData()
        } else if (value === 4) {
            getAreaData()
        } else if (value === 5) {
            getSourceData()
        } else if (value === 6) {
            getTimePeriodData()
        } else if (value === 7) {
            getMetaData()
        }
    }, [props, value]);

    return (
        <>
            <div className="languageTab">
                <Box
                    sx={ {
                        flexGrow: 1,
                        bgcolor: "background.paper",
                        display: "flex",
                        height: 224,
                    } }
                >
                    <div className="manageGidsSidebar">
                        <p className="manageGidsSidebarHeading"> Data Element </p>
                        <Tabs
                            orientation="vertical"
                            variant="scrollable"
                            value={ value }
                            onChange={ handleChange }
                            aria-label="Vertical tabs example"
                            sx={ { borderRight: 1, borderColor: "divider" } }
                        >
                            <Tab label="Indicator" { ...a11yProps(0) } />
                            <Tab label="Unit" { ...a11yProps(1) } />
                            <Tab label="Subgroup" { ...a11yProps(2) } />
                            <Tab label="Subgroup Dimension" { ...a11yProps(3) } />
                            <Tab label="Area" { ...a11yProps(4) } />
                            <Tab label="Source" { ...a11yProps(5) } />
                            <Tab label="Time Period" { ...a11yProps(6) } />
                            <Tab label="Metadata" { ...a11yProps(7) } />
                        </Tabs>

                    </div>
                    <TabPanel value={ value } index={ 0 } className="langTabs">
                        <div className="languageTable">
                            <div className="questionTable">
                                    <div className="row align-items-center" >
                                        <div className="col-md-6">
                                            <div class="db_btn">
                                                <Tooltip title="Export" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#export"
                                                        src="assets/lib/images/manage-form/download_db.svg"
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Import" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#import"
                                                        className="ml-4"
                                                        src="assets/lib/images/manage-form/upload_db.svg"
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div className="col-md-6 ml-auto">
                                            <div className="searchbar-icon mr-0">
                                                <img
                                                    alt=""
                                                    className="search-imgs"
                                                    src="assets/lib/images/manage-form/search.svg"
                                                />
                                                <input
                                                    type="search"
                                                    autoComplete="off"
                                                    className="inpuut"
                                                    value={ searchValue }
                                                    onChange={ (e) => {
                                                        setSearchValue(e.target.value)
                                                    } }
                                                    placeholder="Search..."
                                                />
                                                {/* <input type="search" autoComplete="off" className="inpuut" placeholder="Search..." /> */ }
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <DataTable
                                columns={ columns }
                                data={ indicatorData?.filter(x => x?.name?.toLowerCase()?.includes(searchValue?.toLowerCase())) }
                                pagination
                                persistTableHead
                                noDataComponent="No Data"
                                className="langTable"
                            />
                        </div>
                    </TabPanel>

                    <TabPanel value={ value } index={ 1 } className="langTabs">
                        <div className="languageTable">
                            <div className="questionTable">
                                    <div className="row align-items-center" >
                                        <div className="col-md-6">
                                            <div class="db_btn">
                                                <Tooltip title="Export" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#export"
                                                        src="assets/lib/images/manage-form/download_db.svg"
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Import" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#import"
                                                        className="ml-4"
                                                        src="assets/lib/images/manage-form/upload_db.svg"
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div className="col-md-6 ml-auto">
                                            <div className="searchbar-icon mr-0">
                                                <img
                                                    alt=""
                                                    className="search-imgs"
                                                    src="assets/lib/images/manage-form/search.svg"
                                                />
                                                <input
                                                    type="search"
                                                    autoComplete="off"
                                                    className="inpuut"
                                                    onChange={ (e) => {
                                                        setSearchValue(e.target.value)
                                                    } }
                                                    placeholder="Search..."
                                                />
                                                {/* <input type="search" autoComplete="off" className="inpuut" placeholder="Search..." /> */ }
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <DataTable
                                columns={ columns1 }
                                data={ unitData?.filter(x => x?.name?.toLowerCase()?.includes(searchValue?.toLowerCase())) }
                                pagination
                                persistTableHead
                                noDataComponent="No Data"
                                className="langTable"
                            />
                        </div>
                    </TabPanel>

                    <TabPanel value={ value } index={ 2 } className="langTabs">
                        <div className="languageTable">
                            <div className="questionTable">
                                    <div className="row align-items-center" >
                                        <div className="col-md-6">
                                            <div class="db_btn">
                                                <Tooltip title="Export" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#export"
                                                        src="assets/lib/images/manage-form/download_db.svg"
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Import" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#import"
                                                        className="ml-4"
                                                        src="assets/lib/images/manage-form/upload_db.svg"
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div className="col-md-6 ml-auto">
                                            <div className="searchbar-icon mr-0">
                                                <img
                                                    alt=""
                                                    className="search-imgs"
                                                    src="assets/lib/images/manage-form/search.svg"
                                                />
                                                <input
                                                    type="search"
                                                    autoComplete="off"
                                                    className="inpuut"
                                                    onChange={ (e) => {
                                                        setSearchValue(e.target.value)
                                                    } }
                                                    placeholder="Search..."
                                                />
                                                {/* <input type="search" autoComplete="off" className="inpuut" placeholder="Search..." /> */ }
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <DataTable
                                columns={ columns2 }
                                data={ subgroupData?.filter(x => x?.name?.toLowerCase()?.includes(searchValue?.toLowerCase())) }
                                pagination
                                persistTableHead
                                noDataComponent="No Data"
                                className="langTable"
                            />
                        </div>
                    </TabPanel>

                    <TabPanel value={ value } index={ 3 } className="langTabs">
                        <div className="languageTable">
                            <div className="questionTable">
                                    <div className="row align-items-center" >
                                        <div className="col-md-6">
                                            <div class="db_btn">
                                                <Tooltip title="Export" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#export"
                                                        src="assets/lib/images/manage-form/download_db.svg"
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Import" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#import"
                                                        className="ml-4"
                                                        src="assets/lib/images/manage-form/upload_db.svg"
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div className="col-md-6 ml-auto">
                                            <div className="searchbar-icon mr-0">
                                                <img
                                                    alt=""
                                                    className="search-imgs"
                                                    src="assets/lib/images/manage-form/search.svg"
                                                />
                                                <input
                                                    type="search"
                                                    autoComplete="off"
                                                    className="inpuut"
                                                    onChange={ (e) => {
                                                        setSearchValue(e.target.value)
                                                    } }
                                                    placeholder="Search..."
                                                />
                                                {/* <input type="search" autoComplete="off" className="inpuut" placeholder="Search..." /> */ }
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <DataTable
                                columns={ columns3 }
                                data={ subgroupDimensionData?.filter(x => x?.name?.toLowerCase()?.includes(searchValue?.toLowerCase())) }
                                pagination
                                persistTableHead
                                noDataComponent="No Data"
                                className="langTable"
                            />
                        </div>
                    </TabPanel>

                    <TabPanel value={ value } index={ 4 } className="langTabs">
                        <div className="languageTable">
                            <div className="questionTable">
                                    <div className="row align-items-center" >
                                        <div className="col-md-6">
                                            <div class="db_btn">
                                                <Tooltip title="Export" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#export"
                                                        src="assets/lib/images/manage-form/download_db.svg"
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Import" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#import"
                                                        className="ml-4"
                                                        src="assets/lib/images/manage-form/upload_db.svg"
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div className="col-md-6 ml-auto">
                                            <div className="searchbar-icon mr-0">
                                                <img
                                                    alt=""
                                                    className="search-imgs"
                                                    src="assets/lib/images/manage-form/search.svg"
                                                />
                                                <input
                                                    type="search"
                                                    autoComplete="off"
                                                    className="inpuut"
                                                    onChange={ (e) => {
                                                        setSearchValue(e.target.value)
                                                    } }
                                                    placeholder="Search..."
                                                />
                                                {/* <input type="search" autoComplete="off" className="inpuut" placeholder="Search..." /> */ }
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <DataTable
                                columns={ columns4 }
                                data={ areaData?.filter(x => x?.name?.toLowerCase()?.includes(searchValue?.toLowerCase())) }
                                pagination
                                persistTableHead
                                noDataComponent="No Data"
                                className="langTable"
                            />
                        </div>
                    </TabPanel>

                    <TabPanel value={ value } index={ 5 } className="langTabs">
                        <div className="languageTable">
                            <div className="questionTable">
                                    <div className="row align-items-center" >
                                        <div className="col-md-6">
                                            <div class="db_btn">
                                                <Tooltip title="Export" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#export"
                                                        src="assets/lib/images/manage-form/download_db.svg"
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Import" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#import"
                                                        className="ml-4"
                                                        src="assets/lib/images/manage-form/upload_db.svg"
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div className="col-md-6 ml-auto">
                                            <div className="searchbar-icon mr-0">
                                                <img
                                                    alt=""
                                                    className="search-imgs"
                                                    src="assets/lib/images/manage-form/search.svg"
                                                />
                                                <input
                                                    type="search"
                                                    autoComplete="off"
                                                    className="inpuut"
                                                    onChange={ (e) => {
                                                        setSearchValue(e.target.value)
                                                    } }
                                                    placeholder="Search..."
                                                />
                                                {/* <input type="search" autoComplete="off" className="inpuut" placeholder="Search..." /> */ }
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <DataTable
                                columns={ columns5 }
                                data={ sourceData?.filter(x => x?.name?.toLowerCase()?.includes(searchValue?.toLowerCase())) }
                                pagination
                                persistTableHead
                                noDataComponent="No Data"
                                className="langTable"
                            />
                        </div>
                    </TabPanel>

                    <TabPanel value={ value } index={ 6 } className="langTabs">
                        <div className="languageTable">
                            <div className="questionTable">
                                    <div className="row align-items-center" >
                                        <div className="col-md-6">
                                            <div class="db_btn">
                                                <Tooltip title="Export" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#export"
                                                        src="assets/lib/images/manage-form/download_db.svg"
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Import" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#import"
                                                        className="ml-4"
                                                        src="assets/lib/images/manage-form/upload_db.svg"
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div className="col-md-6 ml-auto">
                                            <div className="searchbar-icon mr-0">
                                                <img
                                                    alt=""
                                                    className="search-imgs"
                                                    src="assets/lib/images/manage-form/search.svg"
                                                />
                                                <input
                                                    type="search"
                                                    autoComplete="off"
                                                    className="inpuut"
                                                    onChange={ (e) => {
                                                        setSearchValue(e.target.value)
                                                    } }
                                                    placeholder="Search..."
                                                />
                                                {/* <input type="search" autoComplete="off" className="inpuut" placeholder="Search..." /> */ }
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <DataTable
                                columns={ columns6 }
                                data={ timePeriodData?.filter(x => x?.name?.toLowerCase()?.includes(searchValue?.toLowerCase())) }
                                pagination
                                persistTableHead
                                noDataComponent="No Data"
                                className="langTable"
                            />
                        </div>
                    </TabPanel>
                    <TabPanel value={ value } index={ 7 } className="langTabs">
                        <div className="languageTable">
                            <div className="questionTable">
                                    <div className="row align-items-center" >
                                        <div className="col-md-6">
                                            <div class="db_btn">
                                                <Tooltip title="Export" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#export"
                                                        src="assets/lib/images/manage-form/download_db.svg"
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Import" placement="top" arrow>
                                                    <img
                                                        alt=""
                                                        data-toggle="modal"
                                                        data-target="#import"
                                                        className="ml-4"
                                                        src="assets/lib/images/manage-form/upload_db.svg"
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div className="col-md-6 ml-auto">
                                            <div className="searchbar-icon mr-0">
                                                <img
                                                    alt=""
                                                    className="search-imgs"
                                                    src="assets/lib/images/manage-form/search.svg"
                                                />
                                                <input
                                                    type="search"
                                                    autoComplete="off"
                                                    className="inpuut"
                                                    onChange={ (e) => {
                                                        setSearchValue(e.target.value)
                                                    } }
                                                    placeholder="Search..."
                                                />
                                                {/* <input type="search" autoComplete="off" className="inpuut" placeholder="Search..." /> */ }
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <DataTable
                                columns={ columns7 }
                                data={ metaData?.filter(x => x?.name?.toLowerCase()?.includes(searchValue?.toLowerCase())) }
                                pagination
                                persistTableHead
                                noDataComponent="No Data"
                                className="langTable"
                            />
                        </div>
                    </TabPanel>
                </Box>
            </div>
            <div className="modal fade export_popups" id="import" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Import</h5>
                            <button type="button" id="importClose" className="close" data-dismiss="modal" aria-label="Close" onClick={ () => window.location.reload() }>
                                <span aria-hidden="true">   <img src="assets/lib/images/cross.svg" alt="" /></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="col-md-12">
                                <div className="img_area text-center mt-4">
                                    {/* <img src="assets/lib/images/import.svg"/> */ }
                                    <svg width="120" height="96" viewBox="0 0 188 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M177.757 85.7574C178.883 84.6321 180.409 84 182 84C183.591 84 185.117 84.6321 186.243 85.7574C187.368 86.8826 188 88.4087 188 90V150H0V90C0 88.4087 0.63214 86.8826 1.75736 85.7574C2.88258 84.6321 4.4087 84 6 84C7.5913 84 9.11742 84.6321 10.2426 85.7574C11.3679 86.8826 12 88.4087 12 90V136C12 136.53 12.2107 137.039 12.5858 137.414C12.9609 137.789 13.4696 138 14 138H174C174.53 138 175.039 137.789 175.414 137.414C175.789 137.039 176 136.53 176 136V90C176 88.4087 176.632 86.8826 177.757 85.7574Z" fill="#A6170A" />
                                        <path className="jumping_arrow" d="M141.537 45.6408C141.227 44.9105 140.772 44.2504 140.2 43.7L98.2002 1.8C97.6585 1.2312 97.0069 0.77837 96.2849 0.46896C95.563 0.159549 94.7857 -4.12829e-06 94.0002 -4.19696e-06C93.2147 -4.26563e-06 92.4374 0.159549 91.7155 0.468959C90.9935 0.778369 90.3419 1.2312 89.8002 1.8L47.8002 43.7C47.2286 44.2504 46.7738 44.9105 46.4632 45.6408C46.1527 46.371 45.9926 47.1564 45.9926 47.95C45.9926 48.7436 46.1527 49.529 46.4632 50.2592C46.7738 50.9895 47.2286 51.6496 47.8002 52.2C48.3419 52.7688 48.9935 53.2216 49.7155 53.531C50.4374 53.8404 51.2147 54 52.0002 54C52.7857 54 53.563 53.8404 54.2849 53.531C55.0069 53.2216 55.6585 52.7688 56.2002 52.2L88.0002 20.5L88.0002 118C88.0002 119.591 88.6323 121.117 89.7575 122.243C90.8828 123.368 92.4089 124 94.0002 124C95.5915 124 97.1176 123.368 98.2428 122.243C99.368 121.117 100 119.591 100 118L100 20.5L131.8 52.2C132.342 52.7688 132.993 53.2216 133.715 53.531C134.437 53.8405 135.215 54 136 54C136.786 54 137.563 53.8405 138.285 53.531C139.007 53.2216 139.658 52.7688 140.2 52.2C140.772 51.6496 141.227 50.9895 141.537 50.2592C141.848 49.529 142.008 48.7436 142.008 47.95C142.008 47.1564 141.848 46.371 141.537 45.6408Z" fill="#A6170A" />
                                    </svg>
                                    <p>Import</p>
                                </div>
                                {
                                    value === 0 &&
                                    <ImportData value={ 50 } />
                                }
                                {
                                    value === 1 &&
                                    <ImportData value={ 51 } />
                                }
                                {
                                    value === 2 &&
                                    <ImportData value={ 52 } />
                                }
                                {
                                    value === 3 &&
                                    <ImportData value={ 53 } />
                                }
                                {
                                    value === 4 &&
                                    <ImportData value={ 54 } />
                                }
                                {
                                    value === 5 &&
                                    <ImportData value={ 55 } />
                                }
                                {
                                    value === 6 &&
                                    <ImportData value={ 56 } />
                                }
                                {
                                    value === 7 &&
                                    <ImportData value={ 57 } />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade export_popups " id="export" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Export</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">
                                    <img src="assets/lib/images/cross.svg" alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="col-md-12">
                                <div className="img_area text-center mt-4">
                                    {/* <img src="assets/lib/images/export.svg"/> */ }
                                    <svg width="120" height="96" viewBox="0 0 188 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M177.757 85.7574C178.883 84.6321 180.409 84 182 84C183.591 84 185.117 84.6321 186.243 85.7574C187.368 86.8826 188 88.4087 188 90V150H0V90C0 88.4087 0.63214 86.8826 1.75736 85.7574C2.88258 84.6321 4.4087 84 6 84C7.5913 84 9.11742 84.6321 10.2426 85.7574C11.3679 86.8826 12 88.4087 12 90V136C12 136.53 12.2107 137.039 12.5858 137.414C12.9609 137.789 13.4696 138 14 138H174C174.53 138 175.039 137.789 175.414 137.414C175.789 137.039 176 136.53 176 136V90C176 88.4087 176.632 86.8826 177.757 85.7574Z" fill="#2A2B6A" />
                                        <path className="jumping_arrow" d="M141.537 78.3592C141.227 79.0895 140.772 79.7496 140.2 80.3L98.2002 122.2C97.6585 122.769 97.0069 123.222 96.2849 123.531C95.563 123.84 94.7857 124 94.0002 124C93.2147 124 92.4374 123.84 91.7155 123.531C90.9935 123.222 90.3419 122.769 89.8002 122.2L47.8002 80.3C47.2286 79.7496 46.7738 79.0895 46.4632 78.3592C46.1527 77.629 45.9926 76.8436 45.9926 76.05C45.9926 75.2564 46.1527 74.471 46.4632 73.7408C46.7738 73.0105 47.2286 72.3504 47.8002 71.8C48.3419 71.2312 48.9935 70.7784 49.7155 70.469C50.4374 70.1596 51.2147 70 52.0002 70C52.7857 70 53.563 70.1596 54.2849 70.469C55.0069 70.7784 55.6585 71.2312 56.2002 71.8L88.0002 103.5L88.0002 6C88.0002 4.40871 88.6323 2.88258 89.7575 1.75736C90.8828 0.632145 92.4089 4.33608e-06 94.0002 4.19696e-06C95.5915 4.05784e-06 97.1176 0.632144 98.2428 1.75736C99.368 2.88258 100 4.4087 100 6L100 103.5L131.8 71.8C132.342 71.2312 132.993 70.7784 133.715 70.469C134.437 70.1595 135.215 70 136 70C136.786 70 137.563 70.1595 138.285 70.469C139.007 70.7784 139.658 71.2312 140.2 71.8C140.772 72.3504 141.227 73.0105 141.537 73.7408C141.848 74.471 142.008 75.2564 142.008 76.05C142.008 76.8436 141.848 77.629 141.537 78.3592Z" fill="#2A2B6A" />
                                    </svg>
                                </div>
                                <div className='d-inline-flex align-item-center w-100'>
                                    <div className="button_box_3 text-center mt-5 mb-40">
                                        {
                                            value === 0 && <ExportWithoutData value={ 50 } />
                                        }
                                        {
                                            value === 1 && <ExportWithoutData value={ 51 } />
                                        }
                                        {
                                            value === 2 && <ExportWithoutData value={ 52 } />
                                        }
                                        {
                                            value === 3 && <ExportWithoutData value={ 53 } />
                                        }
                                        {
                                            value === 4 && <ExportWithoutData value={ 54 } />
                                        }
                                        {
                                            value === 5 && <ExportWithoutData value={ 55 } />
                                        }
                                        {
                                            value === 6 && <ExportWithoutData value={ 56 } />
                                        }
                                        {
                                            value === 7 && <ExportWithoutData value={ 57 } />
                                        }
                                        {
                                            value === 0 && <ExportWithData value={ 50 } />
                                        }
                                        {
                                            value === 1 && <ExportWithData value={ 51 } />
                                        }
                                        {
                                            value === 2 && <ExportWithData value={ 52 } />
                                        }
                                        {
                                            value === 3 && <ExportWithData value={ 53 } />
                                        }
                                        {
                                            value === 4 && <ExportWithData value={ 54 } />
                                        }
                                        {
                                            value === 5 && <ExportWithData value={ 55 } />
                                        }
                                        {
                                            value === 6 && <ExportWithData value={ 56 } />
                                        }
                                        {
                                            value === 7 && <ExportWithData value={ 57 } />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LanguageTab